import axios from "axios"
import { RegistrarLogErro } from "./clientefiel"

// const url = "http://192.168.1.11:3001/api"
const url = "https://zexnxuvx43.execute-api.us-east-1.amazonaws.com/api"

const apiConfiguracaoImpressora = axios.create({
    baseURL: url,
})

function tratamentoResponse(response, chamada) {
    if (response.data.codErro > 0)
        return { retornoErro: response.data.codErro, mensagem: response.data.mensagem }
    else if (typeof response.data == "string" && response.data != "")
        return {
            retornoErro: 1,
            mensagem: chamada + " - Erro inesperado, entre em contato com os reponsáveis.",
        }
    else return response.data
}

const ErroRequisicao = data => {
    try {
        if (data.message === "Network Error") {
            return "Verifique sua conexão!"
        }

        if (data.request && data.request.responseText) {
            const resposta = JSON.parse(data.request.responseText)
            return resposta.mensagem || "Erro desconhecido!"
        }

        return "Erro inesperado na requisição!"
    } catch (error) {
        RegistrarLogErro(error, "ErroRequisicao", data)
        return "Erro ao tratar requisição!"
    }
}

export const listarLayoutsImpressao = async autorizacao => {
    const url = `/configuracoes-impressora/buscar`
    const headers = {
        "Content-Type": "application/json",
        Authorization: autorizacao,
    }

    try {
        const response = await apiConfiguracaoImpressora.get(url, { headers: headers })
        return tratamentoResponse(response, "listarLayoutsImpressao")
    } catch (error) {
        const erro = ErroRequisicao(error)
        RegistrarLogErro(error, "listarLayoutsImpressao")
        return { retornoErro: 1, mensagem: erro }
    }
}

export const buscarLayoutImpressaoPorId = async (id, autorizacao) => {
    const url = `/configuracoes-impressora/buscar/${id}`
    const headers = {
        "Content-Type": "application/json",
        Authorization: autorizacao,
    }

    try {
        const response = await apiConfiguracaoImpressora.get(url, { headers: headers })
        return tratamentoResponse(response, "buscarLayoutImpressaoPorId")
    } catch (error) {
        const erro = ErroRequisicao(error)
        RegistrarLogErro(error, "buscarLayoutImpressaoPorId")
        return { retornoErro: 1, mensagem: erro }
    }
}

export const criarLayoutImpressao = async (data, autorizacao) => {
    const url = `/configuracoes-impressora/criar`
    const headers = {
        "Content-Type": "application/json",
        Authorization: autorizacao,
    }

    try {
        const response = await apiConfiguracaoImpressora.post(url, data, { headers: headers })
        return tratamentoResponse(response, "criarLayoutImpressao")
    } catch (error) {
        const erro = ErroRequisicao(error)
        RegistrarLogErro(error, "criarLayoutImpressao")
        return { retornoErro: 1, mensagem: erro }
    }
}

export const atualizarLayoutImpressao = async (id, data, autorizacao) => {
    const url = `/configuracoes-impressora/${id}/atualizar`
    const headers = {
        "Content-Type": "application/json",
        Authorization: autorizacao,
    }

    try {
        const response = await apiConfiguracaoImpressora.post(url, data, { headers: headers })
        return tratamentoResponse(response, "atualizarLayoutImpressao")
    } catch (error) {
        const erro = ErroRequisicao(error)
        RegistrarLogErro(error, "atualizarLayoutImpressao")
        return { retornoErro: 1, mensagem: erro }
    }
}

export const excluirLayoutImpressao = async (id, autorizacao) => {
    const url = `/configuracoes-impressora/${id}/excluir`
    const headers = {
        "Content-Type": "application/json",
        Authorization: autorizacao,
    }

    try {
        const response = await apiConfiguracaoImpressora.post(url, {}, { headers: headers })
        return tratamentoResponse(response, "excluirLayoutImpressao")
    } catch (error) {
        const erro = ErroRequisicao(error)
        RegistrarLogErro(error, "excluirLayoutImpressao")
        return { retornoErro: 1, mensagem: erro }
    }
}
